/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Switch } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import PaymentsIcon from "@mui/icons-material/Payments";
import InsightsIcon from "@mui/icons-material/Insights";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import AddFee from "../../Modals/addfee";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const initialFeeData = [
    {
        id: 1,
        name: "Product Platform Fee",
        amount: "5%",
        appliesTo: "Product",
        status: true
    },
    {
        id: 2,
        name: "Services Platform Fee",
        amount: "10%",
        appliesTo: "Service",
        status: true
    }
];

const PlatformFees = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [fees, setFees] = useState(initialFeeData);

    const filteredData = fees.filter(fee =>
        fee.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleToggleStatus = (id: number) => {
        setFees(fees.map(fee => fee.id === id ? { ...fee, status: !fee.status } : fee));
    };

    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* PAGE HEADER */}
            <div className="main_title">
                <h1>Platform Fees</h1>
                <p>    <button onClick={() => navigate("/dashboard")}>Dashboard</button> – Platform Fees</p>

            </div>

            {/* STATS BOXES */}
            <div className="stats_boxes gap_m" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
                {/* TOTAL TRANSACTIONS */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            5,423
                            <p>Total Transactions<br/>(30 Days)</p>
                        </h2>
                        <figure className="sucess">
                            <RocketLaunchIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* PLATFORM FEE REVENUE */}
                <a className="cards">
                    <div className="data_top" style={{ alignItems: 'flex-start' }}>
                        <div>
                            <h2>
                                10,846
                            </h2>
                            <p style={{marginTop: '5px', fontSize: '13px', color: '#6b7280'}}>Platform Fee Revenue<br/>(30 Days)</p>
                        </div>
                        <figure className="warning" style={{ alignSelf: 'center' }}>
                            <PaymentsIcon fontSize="large" />
                        </figure>
                    </div>
                </a>

                {/* AVG FEE PER TRANSACTION */}
                <a className="cards">
                    <div className="data_top" style={{ alignItems: 'flex-start' }}>
                        <div>
                            <h2 style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                                2 <span style={{fontSize: '14px', fontWeight: 'bold', color: '#4b5563'}}>AED</span>
                            </h2>
                            <p style={{marginTop: '5px', fontSize: '13px', color: '#6b7280'}}>Avg Fee per Transaction</p>
                            <div style={{marginTop: '10px', fontSize: '11px', color: '#6b7280'}}>
                                <strong style={{color: '#111', fontSize: '12px'}}>20,853 AED</strong> Based on current trend
                            </div>
                        </div>
                        <figure className="purple" style={{ alignSelf: 'center' }}>
                            <InsightsIcon fontSize="large" />
                        </figure>
                    </div>
                </a>
            </div>

            {/* SEARCH & FILTER */}
            <div className="table_flex mt_20">
                <div className="lt">
                    <div className="cards ">
                        <div className="table_header">
                            <div className="left_s">
                                <Box className="search_box">
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search by fee name..."
                                    />
                                </Box>

                                <div className="form">
                                </div>
                            </div>
                            {/* <div className="right_s">
                                <Button className="btn btn_primary" onClick={() => setOpenModal(true)}> <AddIcon /> Add Fee</Button>
                            </div> */}
                        </div>

                        {/* FEES TABLE */}
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Fee Name</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Applies to</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell align="right">Actions</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {filteredData.map((fee) => (
                                        <TableRow key={fee.id} hover>
                                            <TableCell><b>{fee.name}</b></TableCell>
                                            <TableCell><b>{fee.amount}</b></TableCell>
                                            <TableCell>
                                                <span className="badge1">{fee.appliesTo}</span>
                                            </TableCell>
                                            <TableCell>
                                                <Switch
                                                    checked={fee.status}
                                                    onChange={() => handleToggleStatus(fee.id)}
                                                    color="primary"
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton onClick={() => setOpenModal(true)}>
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>
                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>
                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>
                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>
                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>
            <AddFee
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default PlatformFees;
